import classNames from 'classnames';
import PropTypes from 'prop-types';
import './Price.scss';

const Price = ({
  size,
  integer,
  currencySymbol,
  decimals,
  paymentPeriodLabel,
  showDecimals,
  crossed,
  inlineCurrency,
}) => {
  return (
    <div className="main-price-container">
      <p
        className={classNames('main-price', {
          'crossed-price': crossed,
          'main-price-small': size === 'sm',
        })}
      >
        <span className={classNames('price-container-currency', inlineCurrency && 'inline-currency')}>
          {currencySymbol}
        </span>
        <span className="price-container-integer">{integer}</span>
        {showDecimals && <span className="price-container-decimals">{decimals}</span>}
        {paymentPeriodLabel && <span className="price-container-payment-period">{paymentPeriodLabel}</span>}
      </p>
    </div>
  );
};

Price.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
  integer: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  decimals: PropTypes.string.isRequired,
  paymentPeriodLabel: PropTypes.string,
  showDecimals: PropTypes.bool.isRequired,
  crossed: PropTypes.bool,
  inlineCurrency: PropTypes.bool,
};

Price.defaultProps = {
  paymentPeriodLabel: null,
  crossed: false,
  inlineCurrency: false,
  size: 'md',
};

export default Price;
